import React, { useState } from 'react';
import { GalleryLightbox } from './GalleryLightbox';
import { useLanguage } from '../contexts/LanguageContext';
import { galleryPhotos } from '../data/gallery';
import { stable } from '../data/stable';
import { fmt } from '../utils/format';
const VISIBLE = 7;

// Position in the grid decides the tile size: one feature, two side tiles, a row of four.
function tileClass(index: number): string {
  if (index === 0) return 'col-span-2 h-72 sm:h-96 lg:col-span-7 lg:row-span-2 lg:h-auto';
  if (index < 3) return 'col-span-1 h-44 sm:h-56 lg:col-span-5 lg:h-auto';
  return 'col-span-1 h-44 sm:h-56 lg:col-span-3 lg:h-60';
}
export function GallerySection() {
  const {
    t
  } = useLanguage();
  const [active, setActive] = useState<number | null>(null);
  const visible = galleryPhotos.slice(0, VISIBLE);
  const hiddenCount = galleryPhotos.length - VISIBLE;
  return <section id="stable" aria-labelledby="stable-title" className="scroll-mt-16 bg-cream py-20 lg:py-28" data-id="element-145" data-mp="tlp3ybj51jjb">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-146" data-mp="u7gihh0g3k0w">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-147" data-mp="u88cinee99p2">
          <h2 id="stable-title" className="font-serif text-4xl font-bold text-bark md:text-5xl lg:col-span-5" data-id="element-148" data-mp="p6srgvc7v36o">
            {t.gallery.title}
          </h2>
          <p className="text-lg leading-relaxed text-bark/75 lg:col-span-7" data-id="element-149" data-mp="g75s0f31s7g9">{t.gallery.intro}</p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 lg:grid-cols-12 lg:grid-rows-[15rem_15rem] lg:gap-4" data-id="element-150" data-mp="1cx59iz16egaz">
          {visible.map((photo, i) => {
          const isLast = i === visible.length - 1 && hiddenCount > 0;
          return <button key={photo.id} type="button" onClick={() => setActive(i)} aria-label={isLast ? fmt(t.gallery.more, {
            n: hiddenCount
          }) : `${t.gallery.open} ${i + 1}`} className={`group relative overflow-hidden rounded-lg bg-linen focus:outline-none focus-visible:ring-2 focus-visible:ring-hay focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${tileClass(i)}`} data-id="element-151" data-mp="1362a01nwa9dt" data-mpi={i}>
                <img src={photo.src} alt={`${stable.name} ${i + 1}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-152" data-mp="3q4eepztwzsn9" />
                {isLast && <span className="absolute inset-0 flex items-center justify-center bg-bark/55 font-serif text-2xl font-bold text-cream transition-colors duration-200 group-hover:bg-bark/65" data-id="element-153" data-mp="32disdi889pne">
                    {fmt(t.gallery.more, {
                n: hiddenCount
              })}
                  </span>}
              </button>;
        })}
        </div>
      </div>

      <GalleryLightbox photos={galleryPhotos} index={active} onChange={setActive} data-id="element-154" data-mp="qp9dsk4mkpl7" />
    </section>;
}